import {observer} from 'mobx-react';
import React from 'react';
import {ClassroomVideoStore} from './ClassroomVideoStore';

@observer
export class LocalVideoControls extends React.Component<{ store: ClassroomVideoStore }> {
  render() {
    return null;
  }
}
